const translations = {
  "en": {
    " applied": " applied",
    " not applied": " not applied",
    "✓ Invite code ": "✓ Invite code ",
    "Add a referral code": "Add a referral code",
    "Apply code": "Apply code",
    "Back": "Back",
    "Close": "Close",
    "e.g. LXmWwn": "e.g. LXmWwn",
    "Enter invite code": "Enter invite code",
    "Enter it to link up with the friend who invited you. You can skip this.": "Enter it to link up with the friend who invited you. You can skip this.",
    "Enter the code a friend shared with you.": "Enter the code a friend shared with you.",
    "Have a referral code?": "Have a referral code?",
    "Have an invite code?": "Have an invite code?",
    "Referral code ": "Referral code ",
    "That code doesn't match an invite. Check it, or skip and keep going.": "That code doesn't match an invite. Check it, or skip and keep going.",
    "We don't recognise that code. Check it and try again.": "We don't recognise that code. Check it and try again."
  },
  "zh-tw": {
    " applied": "已套用",
    " not applied": "未套用",
    "✓ Invite code ": "✓ 邀請碼",
    "Add a referral code": "新增推薦碼",
    "Apply code": "套用優惠碼",
    "Back": "返回",
    "Close": "關閉",
    "e.g. LXmWwn": "例如 LXmWwn",
    "Enter invite code": "輸入邀請碼",
    "Enter it to link up with the friend who invited you. You can skip this.": "輸入以與邀請您的朋友建立連結。您可跳過此步驟。",
    "Enter the code a friend shared with you.": "輸入朋友分享給你的代碼。",
    "Have a referral code?": "有推薦碼嗎？",
    "Have an invite code?": "有邀請碼嗎？",
    "Referral code ": "推薦碼",
    "That code doesn't match an invite. Check it, or skip and keep going.": "此代碼與邀請不符。請檢查，或跳過並繼續。",
    "We don't recognise that code. Check it and try again.": "無法辨識該代碼。請檢查後重試。"
  }
};

export default translations;
